import axios from '@/utils/http';
// 返佣
export const getCommissionStatistics = (soft = '') => {
  return axios
    .get(`/user_brokerage_statistics?soft=${soft}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getCommissionHistory = (page = 1, per_page = 20) => {
  return axios
    .get(`/user_brokerage_list?page=${page}&per_page=${per_page}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getCommissionRank = () => {
  return axios
    .get('/brokerage_leaderboard')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getInviteeList = (page = 1, per_page = 20) => {
  return axios
    .get(`/invitee_list?page=${page}&per_page=${per_page}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
